import React, { useState, useRef } from 'react';
import HouseSmartMobileNavStyles from './HouseSmartMobileNav.styled';
import BuiltSmartIcon from './icons/BuiltSmartIcon.svg';
import DesignSmartIcon from './icons/DesignSmartIcon.svg';
import EnergySmartIcon from './icons/EnergySmartIcon.svg';
import BudgetSmartIcon from './icons/BudgetSmartIcon.svg';
import { smoothScroll } from '../../Shared/SmokeyTransitional/utils/utils';
import { fireSegmentEvent } from '../../../utils';

export const HouseSmartMobileNav = () => {
  // const [active, setActive] = useState(false);
  // const [activeScrollTo, setActiveScrollTo] = useState(null);
  // const [activePillarImage, setActivePillarImage] = useState(null);
  // const [bGColor, setBGColor] = useState(null);
  // const activeBarRef = useRef(null);

  // function outsideClick() {
  //   setActive(false);
  // }

  // useClickOutside(activeBarRef, outsideClick);

  return (
    <HouseSmartMobileNavStyles>
      <>
        {/* <div
          className={active ? 'active-bar active' : 'active-bar inactive'}
          ref={activeBarRef}
          style={bGColor && { backgroundColor: bGColor }}
          onClick={() => smoothScroll(activeScrollTo, 0) + setActive(false)}
        >
          <img src={activePillarImage} />
        </div> */}

        <ul className="mobile-navbar">
          <li
            onClick={() =>
              smoothScroll('#BuiltSmart', 0) +
              fireSegmentEvent('CTA Clicked', {
                isNav: false,
                type: 'button',
                text: '',
                eventContext: 'housesmart_sticky_nav_builtsmart',
              })
            }
          >
            <img src={BuiltSmartIcon} alt="BuiltSmart Icon" />
          </li>
          <li
            onClick={() =>
              smoothScroll('#DesignSmart', 0) +
              fireSegmentEvent('CTA Clicked', {
                isNav: false,
                type: 'button',
                text: '',
                eventContext: 'housesmart_sticky_nav_designsmart',
              })
            }
          >
            <img src={DesignSmartIcon} alt="DesignSmart Icon" />
          </li>
          <li
            onClick={() =>
              smoothScroll('#EnergySmart', 0) +
              fireSegmentEvent('CTA Clicked', {
                isNav: false,
                type: 'button',
                text: '',
                eventContext: 'housesmart_sticky_nav_energysmart',
              })
            }
          >
            <img src={EnergySmartIcon} alt="EnergySmart Icon" />
          </li>
          <li
            onClick={() =>
              smoothScroll('#BudgetSmart', 0) +
              fireSegmentEvent('CTA Clicked', {
                isNav: false,
                type: 'button',
                text: '',
                eventContext: 'housesmart_sticky_nav_budgetsmart',
              })
            }
          >
            <img src={BudgetSmartIcon} alt="BudgetSmart Icon" />
          </li>
        </ul>
      </>
    </HouseSmartMobileNavStyles>
  );
};

export default HouseSmartMobileNav;
